import { render, staticRenderFns } from "./NewsInstanceGroups.vue?vue&type=template&id=261ccd23&scoped=true&"
import script from "./NewsInstanceGroups.vue?vue&type=script&lang=ts&"
export * from "./NewsInstanceGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ccd23",
  null
  
)

export default component.exports